export function transformScanHistory(history) {
  return {
    text: history.auditString,
    links: history.links || [],
    createdAt: history.createdTime,
    id: history.id,
    owner: history.createdById,
  }
}
